import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { reactive, ref, toRaw } from "vue";
import { Toast } from "@/utils";
import { savePrototypeRegistration } from "@/request/view/prototypeManagement";
import { prototypeMachineStatus, customerType, machineType, loDepartment } from "./options";
import { machineTypeOption } from "../prototypeManagement/machieType.js";
// import staff from "@/components/chooseStaff/staff.vue";
import staff from "@/components/chooseStaff/staffName.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'info',
  emits: ["handleUpdateTable"],
  setup(__props, { expose: __expose, emit: __emit }) {

const formRef = ref();
const machineValue = ref([]);

const formState = reactive({
  applicant: null,
  applicantDept: null,
  applicantPhone: null,
  customerReceiptDetails: null,
  trialDays: null,
  id: null,
  notes: null,
  prototypeAccessory: null,
  prototypeSerial: null,
  prototypeType: null,
  prototypeModel: null,
  status: null,
  trialCustomerType: null,
});

const labelCol = { style: { width: "100px" } };
const wrapperCol = { style: { width: "260px" } };

const validatePhone = async (rule, value: string) => {
  if (!Number.isInteger(Number(value))) {
    return Promise.reject(new Error("请输入数字"));
  }
  const reg = /^1[3456789]\d{9}$/;
  if (reg.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("请输入正确的手机号码"));
};

const rules = {
  applicant: [{ required: true, message: "请选择申请人", trigger: "change" }],
  applicantDept: [{ required: true, message: "请输入申请人所属部门", trigger: "change" }],
  customerReceiptDetails: [{ required: true, message: "请输入收货信息", trigger: "change" }],
  trialDays: [{ required: true, message: "请选择试用天数", trigger: "change", type: "number" }],
  prototypeSerial: [{ required: true, message: "请输入设备机身号", trigger: "change" }],
  prototypeType: [{ required: true, message: "请选择设备类型", trigger: "change" }],
  status: [{ required: true, message: "请选择设备状态", trigger: "change", type: "number" }],
  trialCustomerType: [{ required: true, message: "请选择设备类型", trigger: "change" }],
};

const modalConfig = reactive({
  visible: false,
  title: null,
});

const emit = __emit;

const echoMachineType = () => {
  // if (formState.prototypeType) {
  //   machineTypeOption.forEach((item) => {
  //     const fitem = item.children.find((f) => f.value === formState.prototypeType);
  //     if (fitem) {
  //       machineValue.value.push(item.value, fitem.value);
  //     }
  //   });
  // }
  machineValue.value.push(formState.prototypeType, formState.prototypeModel);
};

const showModal = (type, options) => {
  const { title, data } = options;
  if (type === "update") {
    Object.keys(formState).forEach((key) => {
      formState[key] = data[key];
    });
    echoMachineType();
  }
  if (type === "insert") {
    formState.status = 1;
  }
  modalConfig.title = title;
  modalConfig.visible = true;
};

const handleCancel = () => {
  resetForm();
  modalConfig.title = null;
  modalConfig.visible = false;
};

const getChooseStaff = (e) => {
  const { idList, staffUserName, structureName } = e;
  if (staffUserName.length === 0) {
    formState.applicant = null;
    formState.applicantDept = null;
    return;
  }

  formState.applicant = staffUserName[0];
  formState.applicantDept = structureName[0];
};

const filter = (inputValue, path) => {
  return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
};

const handleSelectPrototypeType = () => {
  const [type, model] = toRaw(machineValue.value);
  formState.prototypeType = type;
  formState.prototypeModel = model;
};

const resetForm = () => {
  machineValue.value.length = 0;
  Object.keys(formState).forEach((key) => {
    formState[key] = null;
  });
  formRef.value.clearValidate();
};

const handleOk = () => {
  formRef.value
    .validateFields()
    .then((res) => {
      savePrototypeRegistration(formState).then((res) => {
        const type = res.code === 200 ? "success" : "warning";
        Toast(type, res.message, 3);
        handleCancel();
        emit("handleUpdateTable");
      });
    })
    .catch((err) => {
      if (err && err.errorFields) {
        const [errText] = err.errorFields[0].errors;
        Toast("warning", errText, 3);
      }
    });
};

__expose({
  showModal,
  handleOk,
  handleCancel,
});

return (_ctx: any,_cache: any) => {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "800px",
    visible: modalConfig.visible,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((modalConfig.visible) = $event)),
    title: modalConfig.title,
    onOk: handleOk,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formState,
        rules: rules,
        layout: "inline",
        "label-col": labelCol,
        "wrapper-col": wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "申请人",
            name: "applicant"
          }, {
            default: _withCtx(() => [
              (modalConfig.visible)
                ? (_openBlock(), _createBlock(staff, {
                    key: 0,
                    staff: formState.applicant,
                    onGetChooseStaff: getChooseStaff,
                    appointDepartment: _unref(loDepartment)
                  }, null, 8, ["staff", "appointDepartment"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "申请人电话",
            name: "applicantPhone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.applicantPhone,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.applicantPhone) = $event)),
                placeholder: "申请人电话",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "申请部门",
            name: "applicantDept"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.applicantDept,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.applicantDept) = $event)),
                placeholder: "申请部门",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "客户类型",
            name: "trialCustomerType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: formState.trialCustomerType,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.trialCustomerType) = $event)),
                options: _unref(customerType),
                placeholder: "客户类型",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "收货信息",
            name: "customerReceiptDetails"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: formState.customerReceiptDetails,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.customerReceiptDetails) = $event)),
                placeholder: "收货信息",
                "auto-size": "",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "设备类型",
            name: "prototypeType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_cascader, {
                value: machineValue.value,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((machineValue).value = $event)),
                "show-search": { filter: filter },
                onChange: handleSelectPrototypeType,
                options: _unref(machineTypeOption),
                placeholder: "设备类型"
              }, null, 8, ["value", "show-search", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "机身号",
            name: "prototypeSerial"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.prototypeSerial,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.prototypeSerial) = $event)),
                placeholder: "机身号",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "配件",
            name: "prototypeAccessory"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: formState.prototypeAccessory,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.prototypeAccessory) = $event)),
                placeholder: "配件",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "使用天数",
            name: "trialDays"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                value: formState.trialDays,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formState.trialDays) = $event)),
                style: {"width":"260px"},
                placeholder: "使用天数"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "设备状态",
            name: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: formState.status,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((formState.status) = $event)),
                options: _unref(prototypeMachineStatus),
                placeholder: "请选择设备状态",
                allowClear: ""
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "备注",
            name: "notes"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_textarea, {
                value: formState.notes,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((formState.notes) = $event)),
                placeholder: "备注",
                "auto-size": "",
                allowClear: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})